var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeeder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1063 9.45961C22.9204 9.73513 22.6097 9.90027 22.2773 9.90027L1.7229 9.90027C1.39054 9.90027 1.07989 9.73514 0.89398 9.45964C0.708067 9.18414 0.671179 8.83427 0.795551 8.52606C1.46425 6.8689 3.03523 5.55911 4.9684 4.67445C6.92394 3.77955 9.36979 3.26038 12.0001 3.26038C14.6305 3.26038 17.0763 3.7797 19.0319 4.67465C20.965 5.55937 22.5359 6.86914 23.2047 8.526C23.3291 8.83422 23.2922 9.1841 23.1063 9.45961ZM20.3659 7.90027C19.8262 7.38815 19.1022 6.90636 18.1996 6.49325C16.5373 5.73251 14.3807 5.26038 12.0001 5.26038C9.61945 5.26038 7.46288 5.73239 5.80064 6.49307C4.89786 6.9062 4.17384 7.38805 3.63413 7.90027L20.3659 7.90027Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2229 2.90027C15.2229 3.45255 14.7752 3.90027 14.2229 3.90027L9.2229 3.90027C8.67062 3.90027 8.2229 3.45255 8.2229 2.90027C8.2229 2.34798 8.67062 1.90027 9.2229 1.90027L14.2229 1.90027C14.7752 1.90027 15.2229 2.34798 15.2229 2.90027Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.936989 11.2816C1.1266 11.0408 1.41617 10.9003 1.72267 10.9003H22.2771C22.5836 10.9003 22.8732 11.0408 23.0628 11.2816C23.2524 11.5224 23.3211 11.8369 23.2492 12.1348C22.0631 17.0512 17.4493 20.6607 11.9999 20.6607C6.5504 20.6607 1.93669 17.0502 0.750567 12.1348C0.678671 11.8369 0.747378 11.5224 0.936989 11.2816ZM3.09447 12.9003C4.46642 16.2478 7.91443 18.6607 11.9999 18.6607C16.0855 18.6607 19.5335 16.2483 20.9054 12.9003H3.09447Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7085 21.0997C5.7085 20.5474 6.15621 20.0997 6.7085 20.0997H17.2915C17.8438 20.0997 18.2915 20.5474 18.2915 21.0997C18.2915 21.652 17.8438 22.0997 17.2915 22.0997H6.7085C6.15621 22.0997 5.7085 21.652 5.7085 21.0997Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeder1);
export default __webpack_public_path__ + "static/media/feeder-1.b4acc0decf320b308b1cd66f0d5327da.svg";
export { ForwardRef as ReactComponent };